// packages/types/src/index.ts

// FIX: Removed direct import from '@prisma/client' to prevent it from being bundled into the frontend.
// Manually defining the enums that are shared between frontend and backend.
// Ensure these definitions accurately reflect your prisma/schema.prisma enums.

export enum BookingStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  PICKED_UP = 'PICKED_UP',
  IN_TRANSIT = 'IN_TRANSIT',
  AT_DELIVERY = 'AT_DELIVERY',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export enum JobStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  DISPUTED = 'DISPUTED',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  ESCROWED = 'ESCROWED',
  RELEASED = 'RELEASED',
  REFUNDED = 'REFUNDED',
  DISPUTED = 'DISPUTED',
}

export enum UserOnboardingStatus {
  pending_documents = 'pending_documents',
  pending_admin_approval = 'pending_admin_approval',
  verified = 'verified',
  auto_verified = 'auto_verified',
}

export enum Role {
  CLIENT = 'CLIENT',
  TRANSPORTER = 'TRANSPORTER',
  ADMIN = 'ADMIN',
  FLEET_MANAGER = 'FLEET_MANAGER',
  FLEET_DRIVER = 'FLEET_DRIVER',
}

export enum VerificationStatus {
  UNVERIFIED = 'UNVERIFIED',
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export enum DocumentType {
  NATIONAL_ID = 'NATIONAL_ID',
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  VEHICLE_REGISTRATION = 'VEHICLE_REGISTRATION',
  PROOF_OF_OWNERSHIP = 'PROOF_OF_OWNERSHIP',
  BUSINESS_REGISTRATION = 'BUSINESS_REGISTRATION',
}

export enum District {
  Balaka = 'Balaka',
  Blantyre = 'Blantyre',
  Chikwawa = 'Chikwawa',
  Chiradzulu = 'Chiradzulu',
  Chitipa = 'Chitipa',
  Dedza = 'Dedza',
  Dowa = 'Dowa',
  Karonga = 'Karonga',
  Kasungu = 'Kasungu',
  Likoma = 'Likoma',
  Lilongwe = 'Lilongwe',
  Machinga = 'Machinga',
  Mangochi = 'Mangochi',
  Mchinji = 'Mchinji',
  Mulanje = 'Mulanje',
  Mwanza = 'Mwanza',
  Mzimba = 'Mzimba',
  Neno = 'Neno',
  NkhataBay = 'NkhataBay',
  Nkhotakota = 'Nkhotakota',
  Nsanje = 'Nsanje',
  Ntcheu = 'Ntcheu',
  Ntchisi = 'Ntchisi',
  Phalombe = 'Phalombe',
  Rumphi = 'Rumphi',
  Salima = 'Salima',
  Thyolo = 'Thyolo',
  Zomba = 'Zomba',
}

export enum WeightUnit {
  KG = 'KG',
  TONNE = 'TONNE',
  POUND = 'POUND',
}

export enum NotificationType {
  // Client Notifications
  JOB_ACCEPTED = 'JOB_ACCEPTED',
  JOB_STATUS_UPDATED = 'JOB_STATUS_UPDATED', // e.g., Picked up, In Transit, Delivered
  JOB_COMPLETED = 'JOB_COMPLETED',
  PAYMENT_RELEASED = 'PAYMENT_RELEASED',

  // Transporter Notifications
  NEW_JOB_AVAILABLE = 'NEW_JOB_AVAILABLE', // Could be for AI matching in the future
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',

  // General Notifications
  ACCOUNT_VERIFIED = 'ACCOUNT_VERIFIED',
  WELCOME = 'WELCOME',
}

export interface UserProfile {
  id: string;
  fullName: string;
  email: string;
  role: 'CLIENT' | 'TRANSPORTER' | 'ADMIN';
}

// You can add more interfaces/types here if they don't depend on @prisma/client

export enum AuditAction {
  // User Auth & Onboarding
  USER_REGISTERED = 'USER_REGISTERED',
  USER_LOGGED_IN = 'USER_LOGGED_IN',
  USER_LOGGED_OUT = 'USER_LOGGED_OUT',
  USER_VERIFICATION_SUBMITTED = 'USER_VERIFICATION_SUBMITTED',
  USER_PROFILE_UPDATED = 'USER_PROFILE_UPDATED',

  // Admin Actions
  ADMIN_USER_APPROVED = 'ADMIN_USER_APPROVED',
  ADMIN_USER_REJECTED = 'ADMIN_USER_REJECTED',
  ADMIN_USER_UPDATED = 'ADMIN_USER_UPDATED',
  ADMIN_VEHICLE_APPROVED = 'ADMIN_VEHICLE_APPROVED',
  ADMIN_VEHICLE_REJECTED = 'ADMIN_VEHICLE_REJECTED',
  ADMIN_VEHICLE_DELETED = 'ADMIN_VEHICLE_DELETED',
  ADMIN_ACCESSED_LOGS = 'ADMIN_ACCESSED_LOGS',
  ADMIN_ACCESSED_USER_DATA = 'ADMIN_ACCESSED_USER_DATA',
  ADMIN_ACCESSED_VEHICLE_DATA = 'ADMIN_ACCESSED_VEHICLE_DATA',
  ADMIN_ACCESSED_JOB_DATA = 'ADMIN_ACCESSED_JOB_DATA',
  ADMIN_ACCESSED_ANALYTICS = 'ADMIN_ACCESSED_ANALYTICS',

  // Transporter Actions
  TRANSPORTER_VEHICLE_ADDED = 'TRANSPORTER_VEHICLE_ADDED',
  TRANSPORTER_VEHICLE_UPDATED = 'TRANSPORTER_VEHICLE_UPDATED',
  TRANSPORTER_VEHICLE_DELETED = 'TRANSPORTER_VEHICLE_DELETED',
  TRANSPORTER_VIEWED_VEHICLES = 'TRANSPORTER_VIEWED_VEHICLES',
  TRANSPORTER_JOB_SECURED = 'TRANSPORTER_JOB_SECURED',
  TRANSPORTER_JOB_STATUS_UPDATED = 'TRANSPORTER_JOB_STATUS_UPDATED',
  TRANSPORTER_VIEWED_ACTIVE_JOBS = 'TRANSPORTER_VIEWED_ACTIVE_JOBS',
  TRANSPORTER_LOCATION_UPDATE = 'TRANSPORTER_LOCATION_UPDATE',
  TRANSPORTER_LOCATION_UPDATE_FAILED = 'TRANSPORTER_LOCATION_UPDATE_FAILED',
  TRANSPORTER_WALLET_TOPUP_INITIATED = 'TRANSPORTER_WALLET_TOPUP_INITIATED',

  // Client Actions
  CLIENT_JOB_POSTED = 'CLIENT_JOB_POSTED',
  CLIENT_JOB_UPDATED = 'CLIENT_JOB_UPDATED',
  CLIENT_JOB_CANCELLED = 'CLIENT_JOB_CANCELLED',
  CLIENT_DELIVERY_CONFIRMED = 'CLIENT_DELIVERY_CONFIRMED',
  CLIENT_REVIEW_LEFT = 'CLIENT_REVIEW_LEFT',
  CLIENT_VIEWED_OWN_JOBS = 'CLIENT_VIEWED_OWN_JOBS',

  // Job & Feed
  JOB_FEED_VIEWED = 'JOB_FEED_VIEWED',
  JOB_VIEWED_DETAILS = 'JOB_VIEWED_DETAILS',

  // Wallet
  USER_VIEWED_WALLET = 'USER_VIEWED_WALLET',

  // Payment
  PAYMENT_WALLET_TOPUP_SUCCESS = 'PAYMENT_WALLET_TOPUP_SUCCESS',
  PAYMENT_BOOKING_FEE_SUCCESS = 'PAYMENT_BOOKING_FEE_SUCCESS',
  PAYMENT_DISPUTED = 'PAYMENT_DISPUTED',
  PAYMENT_RELEASED = 'PAYMENT_RELEASED',
  PAYMENT_WEBHOOK_INVALID_SIGNATURE = 'PAYMENT_WEBHOOK_INVALID_SIGNATURE',
  PAYMENT_WEBHOOK_EVENT_IGNORED = 'PAYMENT_WEBHOOK_EVENT_IGNORED',
  PAYMENT_WEBHOOK_ERROR = 'PAYMENT_WEBHOOK_ERROR',
}